<template>
  <div>
    <el-button type="primary" size="mini" @click="addResForClass">关联内容</el-button>
    <Modal v-model="modalShow" width="760" footer-hide>
      <p slot="header" style="text-align:center;font-size:15px">
        <Icon type="ios-information-circle"></Icon>
        <span>添加资源</span>
      </p>
      <div>
        <el-form :inline="true" :model="formRes" label-width="60px">
          <el-form-item label="ID:">
            <el-input v-model="formRes.id" style="width:130px"></el-input>
          </el-form-item>
          <el-form-item label="名称:">
            <el-input v-model="formRes.name" style="width:130px"></el-input>
          </el-form-item>
          <el-form-item label="CP:">
            <el-select v-model="formRes.cpId" clearable style="width:120px">
              <el-option v-for="item in cpList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onQueryBook">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table
          ref="multipleTable2"
          :data="bookData"
          stripe
          border
          tooltip-effect="dark"
          style="width:100%;font-size:13px"
          @selection-change="handleBookSelectionChange"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="id" label="书籍ID" align="center" width="95"></el-table-column>
          <el-table-column prop="name" label="书籍名称" align="center" min-width="145">
            <template slot-scope="scope">
              <a
                href="javascript:;"
                @click="viewBook(scope.row)"
                style="color:#1d90e6"
              >{{ scope.row.name }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="dbName" label="CP" align="center" width="120"></el-table-column>
          <el-table-column prop="brand" label="书籍品牌" align="center" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.content.brand}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="level" label="级别" align="center" width="90">
            <template slot-scope="scope">
              <span>{{ scope.row.content.level}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="clevel" label="当前状态" width="120" align="center">
             <template slot-scope="scope">
                  <el-tag v-if="scope.row.clevel == 0" type="danger"
                    >已下架</el-tag
                  >
                  <el-tag v-if="scope.row.clevel == 4" type="info"
                    >审核通过</el-tag
                  >
                  <el-tag v-if="scope.row.clevel == 5" type="success"
                    >已上架</el-tag
                  >
                  <el-tag v-if="scope.row.clevel == 2" type="primary"
                    >编辑中</el-tag
                  >
                </template>
          </el-table-column>
        </el-table>
        <el-button type="primary" @click="multyaddBooks" style="margin-top:10px">添加</el-button>
        <div class="pagination-box">
          <el-pagination
            @size-change="handleBookSizeChange"
            @current-change="handleBookCurrentChange"
            :current-page.sync="queryBookParams.page"
            :page-sizes="[20, 50, 100]"
            :page-size="queryBookParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageBookTotal"
          ></el-pagination>
        </div>
      </div>
      <Divider />
      <el-button type="primary" @click="modalConfirm" style="margin-left:350px">确定</el-button>
    </Modal>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
export default {
  name: "courseAddBook",
  components: {},
  data() {
    return {
      modalShow: false,
      cpList: [],
      bookData: [],

      formRes: {
        id: "",
        name: "",
        cpId: "",
      },

      pageBookTotal: 0,
      queryBookParams: {
        page: 1,
        pageSize: 20,
      },
      multipleBookSelection: [],
    };
  },
  props: {
    index: {
      type: Number,
      default: null,
    },
  },
  created() {
    //this.fetchRes();
  },
  watch: {},
  methods: {
    addResForClass() {
      this.modalShow = true;
      this.fetchRes();
    },
    fetchRes() {
      if (this.cpList.length > 0) {
        this.fetchBook().then((res2) => {
          if (res2 != null) {
            this.bookData = JSON.parse(res2);
          }
        });
      } else {
        this.fetchCPList().then((res) => {
          this.cpList = JSON.parse(res);
          this.fetchBook().then((res2) => {
            if (res2 != null) {
              this.bookData = JSON.parse(res2);
            }
          });
        });
      }
    },
    fetchBook() {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
        };
        if (this.formRes.id != "") {
          let bookid = [];
          if (this.formRes.id.indexOf(";") != -1) {
            let arr = this.formRes.id.split(";");
            for (let i in arr) {
              bookid.push(Number(arr[i]));
            }
          } else {
            bookid.push(Number(this.formRes.id));
          }
          params.id = bookid;
        }
        if (this.formRes.name != "") {
          params.name = this.formRes.name;
        }
        let cpidList = [];
        if (this.formRes.cpId != "") {
          cpidList.push(Number(this.formRes.cpId));
        } else {
          this.allAllCp(cpidList);
        }
        var newArr = []//新的数组 获取前100个
        cpidList.forEach((item, index) => {
          // debugger
          if (index <= 99) {
            newArr.push(item)
          }
        })
         params.dbId = newArr;
        params.type = 10;
        params.pageSize = this.queryBookParams.pageSize;
        params.page = this.queryBookParams.page;
        this.$axios
          .post("/aries-api/resource/list", params)
          .then((response) => {
            console.log(response);
            if (response.data.result == 0) {
              this.pageBookTotal = response.data.data.pager.total;
              let arr = response.data.data.list;
              for (let i in arr) {
                arr[i].content = JSON.parse(arr[i].content);
              }
              resolve(JSON.stringify(arr));
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    allAllCp(cpid) {
      for (let i = 0; i < this.cpList.length; ++i) {
        cpid.push(this.cpList[i].id);
      }
    },
    fetchCPList() {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
          onlyAuthorised: 1,
          pid: 0,
        };
        this.$axios
          .post("/aries-api/resourceDb/listAuth", params)
          .then((response) => {
            console.log(response);
            if (response.data.result == 0) {
              resolve(
                JSON.stringify(
                  response.data.data.own.concat(response.data.data.share)
                )
              );
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    handleBookSizeChange(val) {
      this.queryBookParams.pageSize = val;
      this.fetchRes();
    },
    handleBookCurrentChange(val) {
      this.queryBookParams.page = val;
      this.fetchRes();
    },
    handleBookSelectionChange(val) {
      this.multipleBookSelection = val;
    },
    multyaddBooks() {
      this.$emit("choseResult", {
        index: this.index,
        sel: this.multipleBookSelection,
      });
    },
    modalConfirm() {
      this.$emit("choseResult", null);
      this.modalShow = false;
    },
    viewBook(book) {
      let routeUrl = this.$router.resolve({
        name: "addbook",
        query: {
          cpid: book.dbId,
          bookid: book.id,
          do: "view",
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    onQueryBook() {
      this.queryBookParams.page = 1

      this.fetchRes();
    },
  },
};
</script>

<style lang="less">
</style>


// WEBPACK FOOTER //
// courseAddBook.vue?6fa105e0